import React, { SVGProps } from 'react';

const ArcadeIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="100%"
			height="100%"
			viewBox="0 0 19 19"
			fill="none"
			{...props}
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M7.9464 11.3281L4.98554 14.6891C4.68946 14.985 4.30676 15.1789 3.89301 15.2425C3.47925 15.3061 3.05598 15.2362 2.68466 15.0429C2.31334 14.8496 2.01331 14.543 1.82812 14.1676C1.64293 13.7921 1.58223 13.3674 1.65484 12.9552L2.80515 7.03906C2.95375 6.19345 3.39519 5.4271 4.05212 4.87431C4.70904 4.32151 5.53956 4.01753 6.39812 4.01562H12.5934C13.5631 4.01562 14.493 4.40084 15.1787 5.08652C15.7177 5.62554 16.0711 6.31554 16.1976 7.05712L17.3444 12.9552C17.417 13.3674 17.3563 13.7921 17.1711 14.1676C16.9859 14.543 16.6859 14.8496 16.3145 15.0429C15.9432 15.2362 15.52 15.3061 15.1062 15.2425C14.6924 15.1789 14.3097 14.985 14.0137 14.6891L11.0528 11.3281L7.9464 11.3281ZM11.1871 7.35313C10.8557 7.35313 10.5871 7.62175 10.5871 7.95312C10.5871 8.2845 10.8557 8.55312 11.1871 8.55312H12.8746C13.206 8.55312 13.4746 8.2845 13.4746 7.95312C13.4746 7.62175 13.206 7.35313 12.8746 7.35313H11.1871ZM4.9621 7.95312C4.9621 7.62175 5.23073 7.35313 5.5621 7.35313H6.0871V6.82812C6.0871 6.49675 6.35573 6.22813 6.6871 6.22813C7.01847 6.22813 7.2871 6.49675 7.2871 6.82812V7.35313H7.8121C8.14347 7.35313 8.4121 7.62175 8.4121 7.95312C8.4121 8.2845 8.14347 8.55312 7.8121 8.55312H7.2871V9.07812C7.2871 9.4095 7.01847 9.67812 6.6871 9.67812C6.35573 9.67812 6.0871 9.4095 6.0871 9.07812V8.55312H5.5621C5.23073 8.55312 4.9621 8.2845 4.9621 7.95312Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default ArcadeIcon;
